import { render, staticRenderFns } from "./LoadListSkeleton.vue?vue&type=template&id=a7b14fd8&scoped=true"
import script from "./LoadListSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b14fd8",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QItem,QItemSection,QSkeleton,QItemLabel,QCardActions});
